module.exports = __webpack_public_path__ + "img/ico-love.cc18f9bb.png";